// extracted by mini-css-extract-plugin
module.exports = {"filePreviewName":"FileItem_filePreviewName__2krYf","iconButton":"FileItem_iconButton__2Psz4"};